export default function AdminCouriers(){return <div className='p-8'>Admin Couriers</div>}